"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZamLogo = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ZamLogo = exports.ZamLogo = function ZamLogo(props) {
  return _react2.default.createElement("svg", _extends({
    width: 350,
    height: 52,
    viewBox: "0 0 323 52"
  }, props), _react2.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react2.default.createElement("path", {
    d: "M231 4v40",
    stroke: "#979797",
    strokeLinecap: "square"
  }), _react2.default.createElement("g", {
    fillRule: "nonzero"
  }, _react2.default.createElement("path", {
    d: "M46 0H22.327c-6.633 0-10.858 4.772-12.164 10.278-1.02 4.017-1.408 5.893-5.714 22.717v.367L.265 49.45s-1.02 4.772 5.143 1.122l11.51-7.015h18.796c6.735 0 10.857-4.772 12.164-10.38 0-.102 3.183-12.52 5.795-22.9C55.265 3.65 52.367 0 46 0z",
    fill: "#FB713F"
  }), _react2.default.createElement("path", {
    d: "M89.96 15.62H88.101l-1.408 5.323-4.204 15.702h6.55c.838-2.998 4.021-15.131 4.307-15.988.551-3.079-.571-4.853-3.388-5.037zm78.958 0h-1.857l-1.408 5.323-4.204 15.702H168c.837-2.998 4.122-15.131 4.306-15.988.633-3.079-.592-4.853-3.388-5.037zm-59.122 0H97.735L89.98 44.414h6.918l2.061-7.749h5.796c3.184 0 5.245-2.345 5.898-4.955.653-2.61 2.061-7.75 2.898-11.032.837-3.283-.673-5.058-3.755-5.058zm-2.898 5.894c-.102.469-2.245 8.503-2.429 8.972-.102.367-.469.653-.836.653h-3.184l2.898-10.278h3c.653-.102.653.184.551.653zm30.204-5.894l-4.122 14.866c-.102.367-.368.55-.756.653h-1.755c-.285 0-.469-.184-.469-.47v-.183l4.122-14.866h-6.449l-4.122 14.866c-.102.367-.367.55-.755.653h-1.776c-.285 0-.469-.184-.469-.47v-.183l4.122-14.866h-6.449c-1.49 5.425-4.387 15.886-4.49 16.355-.469 1.958 1.225 4.67 3.47 4.67h15.714c2.245 0 5.327-1.774 5.98-4.201.286-1.122 3.184-11.501 4.592-16.824h-6.388zm51.633 0h-12.062l-7.857 28.794h6.919l2.06-7.749h5.715c3.184 0 5.245-2.345 5.898-4.955.653-2.61 2.061-7.75 2.898-11.032.837-3.283-.47-5.058-3.571-5.058zm-2.898 5.792c-.102.469-2.245 8.503-2.429 8.972-.102.367-.47.653-.837.653H179.286l2.898-10.278h3c.755 0 .755.286.653.653zm-102.98.754c.837-.652 1.306-1.672 1.408-2.712.184-1.876-1.224-3.548-3.183-3.732h-13.47l-1.408 5.425h9.367l-11.98 9.34c-.652.652-1.122 1.488-1.122 2.426a3.497 3.497 0 0 0 3.184 3.834H79.122l1.49-5.608H71.45l11.408-8.973zm75.857-6.546h-5.612l2.429-9.074h-6.368l-3.47 12.704-4.652 17.395h6.918l4.306-15.886h3c.653 0 .653.286.551.755 0 .183-2.06 7.85-4.02 15.13h6.449c1.877-7.014 3.837-14.396 4.204-15.987.755-3.262-.653-5.037-3.735-5.037zm37.694.47c.102 0 .102-.103.102-.184v-.184c-.102-.102-.102-.102-.183-.102h-1.96c-.102 0-.183 0-.285.102-.102 0-.102.102-.102.184v.183c.102.102.102.102.183.102h.653l-.755 2.244v.285c0 .102.102.102.184.102.102 0 .184 0 .286-.102.102-.102.183-.184.183-.285l.755-2.244h.653c.102-.02.184-.02.286-.102zm3.368-.388c-.103-.102-.184-.102-.286-.102h-.47c-.102 0-.102.102-.183.102-.102.102-.102.183-.184.285l-1.02 1.673.102-1.673v-.285c0-.102 0-.102-.102-.102h-.47c-.102 0-.183 0-.285.102-.102.102-.184.183-.184.285l-.837 2.427v.286c0 .102.102.102.184.102.102 0 .183 0 .286-.102.102-.102.102-.184.183-.286l.653-2.141-.183 1.958v.367c0 .102 0 .102.102.102s.102.102.183 0c.102 0 .184 0 .286-.102.102 0 .102-.102.184-.184 0-.102.102-.183.183-.285l1.123-1.958-.653 2.141v.286c0 .102.102.102.183.102.102 0 .184 0 .286-.102.102-.102.102-.184.184-.286l.837-2.427c0 .102 0-.081-.102-.183z",
    fill: "#3E444D"
  }), _react2.default.createElement("path", {
    d: "M44.694 11.97c-.102 1.59-.755 2.998-1.96 3.915L26.266 28.773h13.286l-2.143 8.055h-18.98c-2.795 0-5.04-2.14-5.142-4.955v-.55c0-1.408.55-2.61 1.592-3.549l17.306-13.459H18.612l2.061-7.749h18.898c2.715-.102 5.041 2.06 5.143 4.854-.02.183-.02.367-.02.55z",
    fill: "#FFF"
  })), _react2.default.createElement("text", {
    fontFamily: "proxima-nova",
    fontSize: 31,
    letterSpacing: -0.32,
    fill: "#2D323A"
  }, _react2.default.createElement("tspan", {
    x: 262,
    y: 37
  }, "ZAM"))));
};